import style from "./AccountPage.module.scss";
import AccountProfile from "../../components/AppAccount/AccountProfile";
import AccountMenu from "../../components/AppAccount/AccountMenu";
import { useMsal } from "@azure/msal-react";
import Logout from "../../components/AppAccount/Logout";
import AccountSubscriptions from "../../components/AppAccount/AccountSubscriptions";
import FavouritesPage from "../appMode/FavouritesPage";
import AboutUsAndLegal from "../../components/AppAccount/AboutUsAndLegal";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import TabGroup from "../../components/TabGroup/TabGroup";
import AppSavedSearches from "../../components/AppAccount/AppSavedSearches";
import { passwordResetRequest } from "../../authConfig";
import { useState } from "react";
import ManageUsers from "../userProfile/manageUsers";
import {
  hasActiveParentSubscription,
  hasActiveParentSubscriptionSalesforce,
} from "../../utils/authUtils";
import useAuth from "../../hooks/useAuth";
import useSalesforce from "../../hooks/useSalesforce";
import SalesforceAccountSubscriptions from "../../components/AppAccount/SalesforceAccountSubscriptions";
import SalesforceManageUsers from "../userProfile/SalesforceManageUsers";

const AccountPage = ({ profileName, email, isEmailVisible }) => {
  const { instance, accounts } = useMsal();
  const { userProfile: profileData, isInstitution } = useAuth();
  const { isSalesforceEnabled, isSubscribeEnabled } = useSalesforce();
  const navigate = useNavigate();
  const [displayManageUsers, setDisplayManageUsers] = useState(false);

  const parentSubscription = (profileData?.subscriptions ?? []).find(
    (sub) => String(sub.tg_subscriptionid) === "168",
  );

  const handlePasswordReset = () => {
    if (!accounts[0]) {
      console.error("No active account found");
      return;
    }
    instance.loginRedirect(passwordResetRequest).catch((e) => {
      console.error(e);
    });
  };

  const openManageUsers = () => {
    setDisplayManageUsers(true);
  };

  const closeManageUsers = () => {
    setDisplayManageUsers(false);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const accountPageTabs = [
    {
      id: "favourites",
      label: "Favourites",
      component: FavouritesPage,
    },
    {
      id: "savedSearches",
      label: "Saved searches",
      component: AppSavedSearches,
    },
  ];
  console.log(
    "check for manageUsers displayManageUsers",
    displayManageUsers,
    "-hasActiveParentSubscriptionSalesforce(profileData?.subscriptions)",
    hasActiveParentSubscriptionSalesforce(profileData?.subscriptions),
    "-isSalesforceEnabled",
    isSalesforceEnabled,
    "profileData?.subscriptions",
    profileData?.subscriptions,
    "value ---  ---",
    hasActiveParentSubscriptionSalesforce(profileData?.subscriptions) && isSalesforceEnabled,
  );
  return (
    <div className={classNames("medium", style.accountPage)}>
      <div className={style.header}>
        <button className={style.backButton} onClick={handleBackClick}>
          <i className="tg-icons-RightArrow" />
        </button>
        <div className="size-22 medium">My Account</div>
      </div>
      <div className={style.accountContainer}>
        <div className={style.topSection}>
          <div className={style.leftPanel}>
            <AccountProfile name={profileName} email={email} isEmailVisible={isEmailVisible} />
            <div
              onClick={closeManageUsers}
              className={classNames(style.accountHeader, {
                [style.selectedHeader]: !displayManageUsers,
              })}
            >
              My Account
            </div>
            {hasActiveParentSubscription(profileData?.subscriptions) && !isSalesforceEnabled && (
              <div
                className={classNames({
                  [style.selectedHeader]: displayManageUsers,
                })}
              >
                <AccountMenu name="Manage Users" onClickFuc={openManageUsers} hideIcon={true} />
              </div>
            )}
            {hasActiveParentSubscriptionSalesforce(profileData?.subscriptions) &&
              profileData?.contact?.parentMultiUser &&
              isSalesforceEnabled && (
                <div
                  className={classNames({
                    [style.selectedHeader]: displayManageUsers,
                  })}
                >
                  <AccountMenu name="Manage Users" onClickFuc={openManageUsers} hideIcon={true} />
                </div>
              )}
            {!isInstitution && (
              <AccountMenu name="Change password" onClickFuc={handlePasswordReset} />
            )}
            <AccountMenu name="What's new" route="https://www.tg.org.au/news/" isExternal={true} />
            <Logout />
          </div>
          <div className={style.middlePanel}>
            {isSalesforceEnabled ? (
              <SalesforceAccountSubscriptions showHeader={false}></SalesforceAccountSubscriptions>
            ) : (
              <AccountSubscriptions showHeader={false}></AccountSubscriptions>
            )}
            {displayManageUsers ? (
              <div>
                {!isSalesforceEnabled && (
                  <ManageUsers
                    subscriptions={parentSubscription ?? {}}
                    mainAccountContact={profileData?.contact}
                  />
                )}
                {isSalesforceEnabled && isSubscribeEnabled && (
                  <SalesforceManageUsers
                    subscriptions={parentSubscription ?? {}}
                    mainAccountContact={profileData?.contact}
                  />
                )}
              </div>
            ) : (
              <div className={style.tabSection}>
                <TabGroup tabs={accountPageTabs}></TabGroup>
              </div>
            )}
          </div>
        </div>
        <div className={style.rightPanel}>
          <div className={classNames("semibold", style.legalHeader)}>About Us & Legal</div>
          <AboutUsAndLegal showHeader={false}></AboutUsAndLegal>
          <div className={style.disclaimer}>
            <p className={style.paragraph}>We welcome feedback from our community;</p>
            <p>
              please contact{" "}
              <a className={style.underline} href="mailto:feedback@tg.org.au">
                feedback@tg.org.au
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
